import styled from "styled-components";
import {IndicatorDefaultBox} from "./indicator.default.box";

export const IndicatorCasinoMrGreenBox = styled(IndicatorDefaultBox)`
    background: ${({theme}) => theme.colors.backgroundDark};
    box-shadow: inset 0px 0px 5px ${({theme}) => theme.colors.backgroundActive}, inset 0px 0px 10px ${({theme}) => theme.colors.backgroundActive};
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background: ${({theme}) => theme.colors.backgroundDark};
    }
`;
